import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import HomeGate from './pages/HomeGate';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import AccountsPage from './pages/AccountsPage';
import ManagePage from './pages/ManagePage';
import CustomerValue from './pages/CustomerValue';
import TenantsPage from './pages/TenantsPage';
import LedgerPage from './pages/LedgerPage';
import MessagingPage from './pages/MessagingPage';
import AuditPage from './pages/AuditPage';
import InventoryPage from './pages/InventoryPage';
import { ForgotPasswordPage, ResetPasswordPage } from './pages/PasswordPages';
import { TourProvider } from './tour/TourContext';


// ProtectedRoute — redirects to login if not authenticated
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <BrowserRouter>
      <TourProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomeGate />} />
        <Route path="/services" element={<HomePage />} />
        <Route path="/pay" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Protected routes — must be logged in */}
        <Route path="/dashboard" element={
  <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/accounts" element={
          <ProtectedRoute><AccountsPage /></ProtectedRoute>
        } />
        <Route path="/manage" element={
          <ProtectedRoute><ManagePage /></ProtectedRoute>
        } />
        <Route path="/customer-value" element={
          <ProtectedRoute><CustomerValue /></ProtectedRoute>
        } />
        <Route path="/tenants" element={
          <ProtectedRoute><TenantsPage /></ProtectedRoute>
        } />
        <Route path="/ledger" element={
          <ProtectedRoute><LedgerPage /></ProtectedRoute>
        } />
        <Route path="/messaging" element={
          <ProtectedRoute><MessagingPage /></ProtectedRoute>
        } />
        <Route path="/audit" element={
          <ProtectedRoute><AuditPage /></ProtectedRoute>
        } />
        <Route path="/inventory" element={
          <ProtectedRoute><InventoryPage /></ProtectedRoute>
        } />

        {/* Catch all — redirect to home */}
        <Route path="*" element={<Navigate to="/" />}/>
        
      </Routes>
      </TourProvider>
    </BrowserRouter>
  );
}

export default App;